import axios from './axios';
import config from '../../helpers/config';

export default (designId, itemId, numOfCopies) => (
  axios.post(`${config.designBuilderLoadDesignPath}/${designId}/items/${itemId}/copies/${numOfCopies}`)
);
